import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import SecureLS from "secure-ls";
import { jwtDecode } from "jwt-decode";
import NotFound from "../pages/NotFound";

const ls = new SecureLS({ encodingType: "aes" });

const modulePathMapping = {
  SalesReports: "/sales",
  InventoryManagement: [
    "/inventory",
    "/inventory/archive",
    "/inventory/history",
  ],
  MenuItemsCreation: "/menucreation",
  Access: "/access-management",
  AccountManagement: "/account-management",
  Reports: [
    "/reports",
    "/reports/records",
    "/reports/system-logs",
    "/reports/bill-inventory",
    "/reports/bill-history",
    "/reports/customer-details",
    "/reports/customer-history",
  ],
  Configuration: [
    "/config",
    "/config-print",
    "/config-service-charge",
    "/config-gross-sales",
  ],
  Views: [
    "/views",
    "/views/kitchen",
    "/views/cashier",
    "/:posId",
    "/:posId/order",
  ],
  Vouchers: "/vouchers",
  OTPGeneration: ["/account-management/otps"],
  "OTP Generation": ["/account-management/otps"],
  "Toggle Features": ["/account-management/toggles"],
};

const ProtectedRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [authorized, setAuthorized] = useState(true);

  useEffect(() => {
    const user = ls.get("user");
    const authToken = ls.get("authToken");

    if (user && authToken) {
      try {
        const decodedToken = jwtDecode(authToken);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
          ls.remove("user");
          ls.remove("authToken");
          navigate("/login", { replace: true });
        } else {
          const userModules = user.modules || [];
          const pathname = location.pathname;

          if (
            user.role === "Superadmin" ||
            pathname === "/account-management" ||
            pathname === "/dashboard" ||
            (pathname.startsWith("/notifications") &&
              user._id === "672312ec5b53fbbe37d4b0d4") ||
            userModules.some((module) => {
              const paths = modulePathMapping[module];
              if (!paths) return false;

              const currentPath = location.pathname;

              const matchPath = (allowedPath) => {
                if (allowedPath === "/:posId") {
                  return /^\/[^/]+$/.test(currentPath);
                }
                if (allowedPath === "/:posId/order") {
                  return /^\/[^/]+\/order$/.test(currentPath);
                }
                return allowedPath === currentPath;
              };

              return Array.isArray(paths)
                ? paths.some(matchPath)
                : matchPath(paths);
            })
          ) {
            setAuthorized(true);
          } else {
            setAuthorized(false);
          }
        }
      } catch (error) {
        ls.remove("user");
        ls.remove("authToken");
        navigate("/login", { replace: true });
      }
    } else {
      navigate("/login", { replace: true });
    }
  }, [navigate, location]);

  if (!authorized) {
    return <NotFound />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
